import { render } from "./PersonalitiesCard.vue?vue&type=template&id=0eccc588"
import script from "./PersonalitiesCard.vue?vue&type=script&lang=js"
export * from "./PersonalitiesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__